export const API_VERSION = '0.0.1';
export const API_ROOT = '/api';
